export default {
  Filter: {
    User: 'User',
    Event: 'Event',
  },
  ShowInactiveShifts: 'Show inactive shifts',
};
